import { KeycloakService } from 'keycloak-angular';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AccessControlService } from '../access-control/services/access-control.service';
import { RegistroService } from '../registro.service';

export function initializeKeycloak(
    keycloak: KeycloakService,
    accessControlService: AccessControlService,
    registroService: RegistroService
) {
    return async () => {
        const authenticated = await keycloak.init({
            config: {
                url: environment.keycloakConf.url,
                realm: environment.keycloakConf.realm,
                clientId: environment.keycloakConf.clientId,
            },
            initOptions: {
                onLoad: 'login-required',
                pkceMethod: 'S256',
                // false porque el chequeo periódico de sesión de keycloak-js
                // depende de un iframe de terceros hacia el origen de Keycloak,
                // y falla con "Timeout when waiting for 3rd party check iframe
                // message." en cualquier navegador/modo que bloquee cookies de
                // terceros (incógnito, Safari, Firefox), impidiendo el redirect
                // a login. Con onLoad: 'login-required' no se necesita para
                // autenticar; solo se pierde la detección de logout en otra pestaña.
                checkLoginIframe: false,
            },
        });

        if (authenticated) {
            try {
                const permisos = await firstValueFrom(
                    accessControlService.getPermisosByAuthUsuario()
                );
                registroService.permisos = permisos ?? [];
            } catch (error) {
                console.error(
                    'No fue posible cargar los permisos del usuario autenticado:',
                    error
                );
                registroService.permisos = [];
                const mensaje =
                    typeof error === 'string'
                        ? error
                        : (error as { message?: string })?.message ?? '';
                if (
                    mensaje.toLowerCase().includes('usuario inactivo')
                ) {
                    await new Promise((resolve) => setTimeout(resolve, 2000));
                    await keycloak.logout();
                    return false;
                }                
            }
        }

        return authenticated;
    };
}
